/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MinusIcon16Solid = forwardRef('MinusIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1 8.5A1.5 1.5 0 0 1 2.5 7h10a1.5 1.5 0 0 1 0 3h-10A1.5 1.5 0 0 1 1 8.5Z" })));
});
